import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M21.904 18.2059C21.903 18.2049 21.902 18.2029 21.901 18.2019L12.405 5.20594C12.405 5.20594 12.405 5.20594 12.404 5.20594C12.374 5.16494 12.337 5.12694 12.293 5.09494C12.07 4.93294 11.757 4.98194 11.595 5.20594H11.594L2.09396 18.2059C1.93196 18.4289 1.98096 18.7419 2.20496 18.9039C2.29496 18.9689 2.39796 18.9999 2.49996 18.9999H21.5C21.602 18.9999 21.705 18.9689 21.794 18.9049C22.017 18.7419 22.067 18.4299 21.904 18.2059V18.2059Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'RoundedTriangleUpFill');

export default Icon;
